import type { GradeAxes } from "../../api/contract";

interface DrillGradeProps {
  grade: GradeAxes;
}

const overallStyles: Record<GradeAxes["overall"], string> = {
  match: "grade-match",
  valid_alternative: "grade-valid-alt",
  wrong: "grade-wrong",
};

const overallLabels: Record<GradeAxes["overall"], string> = {
  match: "Match",
  valid_alternative: "Valid alternative",
  wrong: "Wrong",
};

type AxisKey = "lemma" | "particles" | "order" | "register" | "negation";

const axes: { key: AxisKey; label: string }[] = [
  { key: "lemma", label: "Vocabulary" },
  { key: "particles", label: "Particles" },
  { key: "order", label: "Word order" },
  { key: "register", label: "Register" },
  { key: "negation", label: "Negation" },
];

export function DrillGrade({ grade }: DrillGradeProps) {
  return (
    <div className="rounded-lg border p-4">
      <div className="mb-3 flex items-center gap-2">
        <span className="text-sm font-medium">Grade:</span>
        <span
          className={`text-sm font-semibold ${overallStyles[grade.overall]}`}
        >
          {overallLabels[grade.overall]}
        </span>
      </div>

      <div className="grid gap-1.5 text-sm">
        {axes.map(({ key, label }) => (
          <div key={key} className="flex gap-2">
            <span className="text-muted-foreground w-24 shrink-0 font-medium">
              {label}
            </span>
            <span>{grade[key]}</span>
          </div>
        ))}
      </div>

      {grade.comment && (
        <p className="text-muted-foreground mt-3 text-sm italic">
          {grade.comment}
        </p>
      )}
    </div>
  );
}
